import React, { useEffect, useRef, useState } from 'react'
import { Images } from '../../../global/GloblImages.tsx'
import { useLocation, useNavigate } from 'react-router-dom'
import { ApiGetResend2FA, ApiUsersLogin } from '../../../apiService/Core/Apicall.tsx'
import { roleRedirects } from '../../../global/constants/roleRedirects.tsx'
import { toast, ToastContainer } from 'react-toastify'
import { Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../../global/config/store.ts'
import { fetchClientList } from '../../../global/config/Reducer/clientSlice.ts'

function OtpVerification() {
    const icons: any = Images()

    const [otp, setOtp] = useState<string[]>(Array(6).fill(''))
    const [error, setError] = useState('')
    const inputRefs = useRef<(HTMLInputElement | null)[]>([])
    const location = useLocation()
    const { username, password, tempToken } = location.state || {}
    const navigate = useNavigate()
    const [token, setToken] = useState()
    const [userName, setUserName] = useState()
    const [Password, setPassword] = useState()
    const [resendTimer, setResendTimer] = useState(120)
    const [callApi, setCallApi] = useState<boolean>(false)
    const dispatch = useDispatch<AppDispatch>();



    useEffect(() => {
        if (callApi) {
            dispatch(fetchClientList());
        }
    }, [dispatch, callApi]);
    
    useEffect(() => {
        if (resendTimer <= 0) return

        const timer = setInterval(() => {
            setResendTimer(prev => {
                if (prev <= 1) {
                    clearInterval(timer)
                    return 0
                }

                return prev - 1
            })
        }, 1000)

        return () => clearInterval(timer)
    }, [resendTimer])

    const formatTimer = (seconds: number) => {
        const minutes = Math.floor(seconds / 60)
        const remainingSeconds = seconds % 60

        return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`
    }

    useEffect(() => {
        if (!username && !password && !tempToken) {
            navigate(-1)
        }
        setToken(tempToken)
        setPassword(password)
        setUserName(username)
        navigate(location.pathname, {
            replace: true,
            state: null
        })
    }, [])

    const handleOtpChange = (value: string, index: number) => {
        // Allow only numbers
        if (!/^\d*$/.test(value)) return

        const newOtp = [...otp]
        newOtp[index] = value.slice(-1)
        setOtp(newOtp)
        setError('')

        // Move to next input
        if (value && index < 5) {
            inputRefs.current[index + 1]?.focus()
        }
    }

    const handleKeyDown = (
        e: React.KeyboardEvent<HTMLInputElement>,
        index: number
    ) => {
        // Move back when pressing backspace on empty input
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            inputRefs.current[index - 1]?.focus()
        }
    }

    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
        e.preventDefault()

        const pastedData = e.clipboardData
            .getData('text')
            .replace(/\D/g, '')
            .slice(0, 6)

        if (!pastedData) return

        const newOtp = Array(6).fill('')

        pastedData.split('').forEach((digit, index) => {
            newOtp[index] = digit
        })

        setOtp(newOtp)

        // Focus last entered / next input
        const nextIndex = Math.min(pastedData.length, 5)
        inputRefs.current[nextIndex]?.focus()
    }

    const handleVerify = async (e: React.FormEvent) => {
        e.preventDefault()
        const otpValue = otp.join('')
        if (otpValue.length !== 6) {
            setError('Please enter the 6-digit OTP')
            return
        }
        try {
            const loginData = {
                emailId: userName,
                password: Password,
                otp: otpValue,
                tempToken: token

            }
            const response: any = await ApiUsersLogin(loginData)
            if (!response?.status) {
                console.log("Response", response)
            }
            if (response?.userDetails) {
                setCallApi(true)
                const user = response.userDetails
                if (["1", "2", "3"].includes(String(user.role.roleId))) {
                    localStorage.setItem('userRole', user.role.roleId)
                    localStorage.setItem('userId', user.userId)
                    localStorage.setItem('userStatusId', user.userStatus.userStatusId)
                    localStorage.setItem('createdBy', user.userId)
                    localStorage.setItem('user', user)
                    localStorage.setItem('userName', user.displayName)
                    localStorage.setItem('userRoleName', user.role.roleDisplayName)
                    localStorage.setItem('useremail', user.emailId)
                    // localStorage.setItem('editorId', user)
                    localStorage.setItem('token', response.token)

                    const redirectUrl = roleRedirects[user.role.roleId] || '/login'
                    navigate(redirectUrl)
                }
                else {
                    toast.error("Invalid Access")
                    navigate('/login')
                }
            }
            else {
                setError(response?.message || "Invalid OTP. Please try again.")
            }
        }
        catch (error: any) {
            toast.error(error?.message || "Invalid OTP. Please try again")
            setError(error?.message || "Invalid OTP. Please try again.")
            console.error('Error during API call:', error)
        }
    }



    const ResendOTP = async () => {
        if (resendTimer > 0) return
        try {
            const loginData = {
                tempToken: token
            }
            const response: any = await ApiGetResend2FA(loginData)
            if (response?.status) {
                // setToken(response?.tempToken)
                setResendTimer(120)
                toast.success(response?.message)
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went worng")
            console.error('Error during API call:', error)
        }
    }

    return (
        <div
            className='login-banner'
            style={{
                backgroundImage: `url(${icons.LoginBanner})`
            }}
        >
            <ToastContainer />
            <form onSubmit={handleVerify} id='formOtpVerification'>
                <div className='row'>
                    <div
                        className='col-md-5 col-sm-12 offset-sm-0 offset-lg-4 p-sm-5'
                        style={{ margin: 'auto', maxWidth: '520px !important' }}
                    >
                        <div className='team-item p-lg-5 p-sm-3'>

                            {/* Logo */}
                            <div style={{ textAlign: 'center' }}>
                                <img
                                    src={icons.mmLogo}
                                    width={'40%'}
                                    alt='Mystery Management'
                                />
                            </div>

                            <div className='team-content'>
                                <br />

                                <h3 className='box-title m-b-20 text-center'>
                                    Verify OTP
                                </h3>

                                <p
                                    className='text-center'
                                    style={{
                                        color: '#777',
                                        marginBottom: '25px'
                                    }}
                                >
                                    Enter the 6-digit OTP sent to your email
                                </p>

                                {/* OTP Inputs */}
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        gap: '10px',
                                        marginBottom: '10px'
                                    }}
                                >
                                    {otp.map((digit, index) => (
                                        <input
                                            key={index}
                                            ref={el => {
                                                inputRefs.current[index] = el
                                            }}
                                            type='text'
                                            inputMode='numeric'
                                            maxLength={1}
                                            value={digit}
                                            onChange={e =>
                                                handleOtpChange(e.target.value, index)
                                            }
                                            onKeyDown={e => handleKeyDown(e, index)}
                                            onPaste={handlePaste}
                                            autoComplete='one-time-code'
                                            style={{
                                                width: '45px',
                                                height: '50px',
                                                textAlign: 'center',
                                                fontSize: '22px',
                                                fontWeight: '600',
                                                border: '1px solid #ddd',
                                                borderRadius: '6px',
                                                outline: 'none'
                                            }}
                                        />
                                    ))}
                                </div>

                                {/* Error */}
                                {error && (
                                    <div
                                        className='text-danger  text-center'
                                        style={{ marginTop: '8px' }}
                                    >
                                        {error}
                                    </div>
                                )}

                                {/* Verify Button */}
                                <div className='form-group text-center mt-2'>
                                    <div className='col-xs-12'>
                                        <button
                                            type='submit'
                                            style={{
                                                background:
                                                    'linear-gradient(175deg, #ccd3b4 4.38%, #607438 111.49%)',
                                                color: 'white',
                                                border: 'none'
                                            }}
                                            className='btn btn-lg btn-block text-uppercase waves-effect waves-light mb-0'
                                        >
                                            Verify OTP
                                        </button>
                                    </div>
                                </div>

                                {/* Resend OTP */}

                                <div
                                    className='text-center'
                                    style={{ marginTop: '20px' }}
                                >
                                    <span style={{ color: '#777' }}>
                                        Didn't receive the OTP?
                                    </span>{' '}
                                    {resendTimer > 0
                                        ?
                                        <Typography variant='subtitle2'>Resend OTP in {formatTimer(resendTimer)}</Typography>
                                        :
                                        <button
                                            type='button'
                                            // disabled={resendTimer > 0}
                                            style={{
                                                border: 'none',
                                                background: 'none',
                                                color: '#607438',
                                                fontWeight: '600',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => {
                                                ResendOTP()
                                            }}
                                        >
                                            Resend OTP
                                        </button>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default OtpVerification